import React, { useContext, useState } from 'react';
import { AuthContext } from '../../shared/context/auth-context';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { Button } from '@mui/material';

import './createPost.css';

// import Input from '../../shared/components/FormElements/input';

const CreatePost = () => {
  const auth = useContext(AuthContext);
  const { user } = useContext(AuthContext);
  
    const history = useHistory()
   
    const [inputData, setInputData] = useState(
        {
            title: '',
            post: '',
            media: null,
            creator: user.id
        }
    );
    const [isLoading, setIsLoading] = useState(false)

    const inputHandler = (e) => {
        const { id, value } = e.target;
        setInputData((prevState) => ({
            ...prevState,
            [id]: value
        }))
    }

    const fileHandler = (e) => {
        const file = e.target.files[0];
        setInputData((prevState) => ({
            ...prevState,
            media: file
        }))
    }

    const submitHandler = async (e) => {
        e.preventDefault();
        const isConfirmed = window.confirm("Are you sure to Post it?");

        if(!isConfirmed){
          console.log("Post action cancelled! ")
          return;
        };

        setIsLoading(true);

        try{
          const formData = new FormData();
          formData.append('title', inputData.title);
          formData.append('post', inputData.post);
          formData.append('media', inputData.media);
          formData.append('creator', user.id);
          

        
          const response = await fetch(process.env.REACT_APP_BACKEND_URL + '/posts', {
            method: 'POST',
            body: formData,
            headers: {
              'Authorization': 'Bearer ' + auth.token
            }
          
            
          });
         
          const responseData = await response.json();
          console.log(responseData);


          if(!response.ok){
            throw new Error(responseData.message || 'Failed to create post')
          }
        }
        catch (err){
          console.log(err)
        }

        // if(isConfirmed){
        //   try {
        //   const response = await fetch(process.env.REACT_APP_BACKEND_URL + '/posts', {
        //     method: 'POST',
        //     headers: {
        //       'Content-Type' : 'application/json'
        //     },
        //     body: JSON.stringify(inputData)
        //   });
        //   const responseData = await response.json();
        //   console.log(responseData);
        // } catch (err) {
        //   console.log(err);
        // }
        // }
        

        if(isConfirmed){
            console.log('User: ', inputData);
            history.push('/posts');
        } else {
            console.log('Post action cancelled')
        }   
    };
    
  return (
    <main className='cPost-container'>
      <h1>Create New Post</h1>
      <div className='cPost-form-container'>
        <div className='cPost-name-img'>
          <a href='/user'><img src={`${process.env.REACT_APP_ASSET_URL}/${user.image}`} alt='pic'/> </a>
          {!isLoading && user.name} 
        </div>
        <form onSubmit={submitHandler} className='cPost-form'>
          <input type="text" id='title' placeholder='Post title (Optional)'  onChange={inputHandler} />
          <textarea id='post' placeholder='Write your post...'  onChange={inputHandler} className='cPost-textarea'/>
          <input type="file" id='img'  accept='image/*,video/*' onChange={fileHandler}/>
          <Button type="submit" variant='contained'>Post</Button>
        </form>

      </div>
    </main>
  )
}
export default CreatePost;